import * as actions from '../../redux/actions';
import * as commonActions from '../../../common/redux/actions';
import * as homeActions from '../../../home/redux/actions';

import { KuposErrorSuccessModal, KuposInput } from '../../../common';
import React, { useState } from 'react';

import { AppData } from '../../../../services';
import CommonService from '../../../../services/commonService';
import KuposHelmet from '../../../common/KuposHelmet';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

const initialState = {
	name: null,
	nameError: null,
	email: null,
	emailError: null,
	phone: null,
	phoneError: null,
	comment: null,
	commentError: null,
};
const ThemeSevenContactScreen = props => {
	const operator = CommonService.getLocal('op') || props.home.operator;
	const [state, setState] = useState(initialState);

	const onChange = (value, type) => {
		if (type == 'phone') {
			value = CommonService.phoneNumberFormat(value);
			setState({
				...state,
				[type]: value,
				[type + 'Error']: false,
			});
		} else {
			setState({ ...state, [type]: value, [type + 'Error']: false });
		}
	};

	const validate = () => {
		let errorCount = 0;
		if (!state.name) {
			setState({ ...state, nameError: true, nameErrorMessage: 'Ingresa tu nombre' });
			errorCount++;
		} else if (!state.phone) {
			setState({ ...state, phoneError: true, phoneErrorMessage: 'Ingresa tu número de teléfono' });
			errorCount++;
		} else if (!state.email) {
			setState({ ...state, emailError: true, emailErrorMessage: 'Ingrese un email valido' });
			errorCount++;
		} else if (!state.comment) {
			setState({
				...state,
				commentError: true,
				commentErrorMessage: 'Inserta tu comentario',
			});
			errorCount++;
		}

		if (errorCount > 0) {
			return false;
		} else {
			return true;
		}
	};
	const onSubmit = () => {
		if (!validate()) {
			return;
		}
		if ((operator.operator_name === 'fernandez')) {

			let data = {
				name: state.name,
				last_name: null,
				email: state.email,
				phone_number: state.phone,
				comments: state.comment,
				operator_id: operator.operator_id,
				operator_name: operator.operator_name,
			};
			props.actions
				.apiCall({
					url: AppData.BASE_URL + 'api/opsite_contact_info',
					method: 'POST',
					data,
				})
				.then(
					res => onContactInfoResponse(res),
					err => onContactInfoResponse(err),
				);
		}
	};

	const onContactInfoResponse = res => {
		if (res && res.data && res.data.message) {
			setState({
				...state,
				showModal: true,
				responseMessage: res.data.message,
				status: res.data.status,
			});
		}
	};
	return (
		<div className="themes-theme-seven-contact-screen">
			<KuposHelmet />

			<div id="contact">
				<div className="new-container">
					<div className="heading">
						<h1>Contacto</h1>
					</div>
				</div>
			</div>

			{/* --------------------- */}
			<div className="new-container">
				<div className="contact">
					<h3>
						<span>Contáctanos</span>
					</h3>
					<h5>
						Te ayudamos a <span>solucionar</span> cualquier <span>duda o inconveniente</span>{' '}
						durante el proceso de compra en línea, anulación de pasajes y devoluciones.
					</h5>
					<div className="contact-section">
						<div className="col-md-12">
							<div className="info">
								<div className="w50 bdr-rt">
									<div className="address">
										<span>Punta Arenas</span>
										<span>Horarios de Atención: 07:45 - 22:00 hrs.</span>
									</div>
									<div className="c-flex-row">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Telephone.svg"
											alt="support"
										/>
										<span>+56 61 2242 313 / +56 9 9326 0974</span>
									</div>
									<div className="c-flex-row">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Location.svg"
											alt="location"
										/>
										<span>Armando Sanhueza #745</span>
									</div>
									<div className="c-flex-row">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Email.svg"
											alt="email"
										/>
										<span
										// style="word-break: break-all;"
										>
											pasajespuntaarenas@busesfernandez.com
										</span>
									</div>
								</div>
								<div className="">
									<div className="address">
										<span>Puerto Natales</span>
										<span>Horarios de Atención: 07:00 - 22:00 hrs.</span>
									</div>
									<div className="c-flex-row">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Telephone.svg"
											alt="support"
										/>
										<span>+56 61 2414 786 / +56 61 2411 111</span>
									</div>
									<div className="c-flex-row">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Location.svg"
											alt="location"
										/>
										<span>Eleuterio Ramirez #399 / Av. España #1455</span>
									</div>
									<div className="c-flex-row">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Email.svg"
											alt="email"
										/>
										<span
										// style="word-break: break-all;"
										>
											operadornatales@busesfernandez.com
										</span>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="form-section">
						<div className="col-md-12">
							<div className="form">
								{/* <form
									accept-charset="UTF-8"
									action="/feedbacks/create_feedback"
									className="form-contact"
									data-remote="true"
									id="contact_form"
									method="post"
								> */}
								<div className="d-flex">
									<div className="col-md-4">
										<div className="form-group">
											<label for="username">Nombre completo</label>
											<KuposInput
												type="text"
												placeholder="Nombre"
												value={state.name}
												error={state.nameError}
												errorMessage={state.nameErrorMessage}
												onChange={val => onChange(val, 'name')}
											/>
											{/* <input
												placeholder="Ej. Maria"
												className="form-control"
												maxlength="20"
												required="required"
												size="20"
												type="text"
												name="feedback[username]"
												id="feedback_username"
											/> */}
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<label for="email">Email</label>
											{/* <input
												placeholder="ejemplo@gmail.com"
												className="form-control"
												maxlength="30"
												required="required"
												size="30"
												type="text"
												name="feedback[email]"
												id="feedback_email"
											/> */}
											<KuposInput
												type="email"
												placeholder="Email"
												value={state.email}
												error={state.emailError}
												errorMessage={state.emailErrorMessage}
												onChange={val => onChange(val, 'email')}
											/>
										</div>
									</div>
									<div className="col-md-4">
										<div className="form-group">
											<label for="contact_number">Nº de contacto</label>
											{/* <input
												placeholder="+56 9 0000 0000"
												className="form-control"
												maxlength="30"
												required="required"
												size="30"
												type="text"
												name="feedback[contact_number]"
												id="feedback_contact_number"
											/> */}
											<KuposInput
												type="number"
												placeholder="Teléfono"
												value={state.phone}
												error={state.phoneError}
												errorMessage={state.phoneErrorMessage}
												onChange={val => onChange(val, 'phone')}
											/>
										</div>
									</div>
								</div>

								<div className="col-md-12">
									<div className="form-group">
										<label for="comments">Mensaje</label>
										{/* <textarea
											placeholder=""
											className="form-control"
											maxlength="2000"
											required="required"
											name="feedback[comments]"
											id="feedback_comments"
										></textarea> */}
										<br />
										<textarea
											className="text-area font12 form-group w-100"
											rows={8}


											onChange={e => onChange(e.target.value, 'comment')}
										/>
									</div>
									<div className="form-group text-center">
										<button className="btn btn-success hvr-back-pulse" id="submit_btn" onClick={() => {
											onSubmit();
										}}>
											ENVIAR
										</button>
										<KuposErrorSuccessModal
											success={state.status == 200 ? true : false}
											showModal={state.showModal}
											onButtonClick={() => {
												setState({ showModal: false });
												window.location.reload();
											}}
											bodyText={state.responseMessage}
										/>
									</div>
								</div>
								{/* </form> */}
								<div className="clearfix"></div>
							</div>
						</div>
					</div>
					<div className="support-section">
						<div className="col-md-12">
							<div className="support">
								<h5>
									<span>Soporte para compras en línea</span>
								</h5>
								<div className="d-flex">
									<div className="col-sm-4 text-center">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Telephone.svg"
											alt="support"
										/>
										<span>+56 9 4915 6683</span>
									</div>
									<div className="col-sm-4 text-center">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-2-WhatsApp.svg"
											alt="support"
										/>
										<span>+56 9 4915 6683</span>
									</div>
									<div className="col-sm-4 text-center">
										<img
											src="/assets/fernandez/contact/BusesFernandez-Website-Contact-Email.svg"
											alt="support"
										/>
										<span>ayuda@pasajebus.com</span>
									</div>
								</div>

								<div className="clearfix"></div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
function mapStateToProps(state) {
	return {
		home: state.home,
	};
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators({ ...actions, ...homeActions, ...commonActions }, dispatch),
	};
}

// /* istanbul ignore next */
// function mapStateToProps(state) {
// 	return {
// 		themes: state.themes,
// 		home: state.home,
// 	};
// }
export default connect(
	mapStateToProps,
	mapDispatchToProps,
)(withTranslation('common')(ThemeSevenContactScreen));



// WEBPACK FOOTER //
// ./src/features/themes/ThemeSeven/ThemeSevenPages/ThemeSevenContactScreen.js